(function(){
  'use strict';
  if(window.__dxj)return;window.__dxj=1;
  var RM=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function all(q,r){return Array.prototype.slice.call((r||document).querySelectorAll(q));}
  function cl(v,a,b){return Math.max(a,Math.min(b,v));}
  function esc(x){return String(x==null?'':x).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function ready(f){if(document.readyState!=='loading')f();else document.addEventListener('DOMContentLoaded',f);}
  function hdBottom(){
    var b=0,els=document.elementsFromPoint?document.elementsFromPoint(window.innerWidth/2,2):[];
    for(var i=0;i<els.length;i++){
      var p=els[i];if(p.closest('.dxj__tags,.dxa__prog,.dxa__side,[data-dxbc]'))continue;
      while(p&&p!==document.body&&p!==document.documentElement){
        var ps=getComputedStyle(p).position;
        if(ps==='sticky'||ps==='fixed'){var r=p.getBoundingClientRect();if(r.top<=2&&r.height<320&&r.bottom>b)b=r.bottom;break;}
        p=p.parentElement;
      }
    }
    return Math.max(0,Math.round(b));
  }
  function slug(s){
    s=String(s||'').toLowerCase();if(s.normalize)s=s.normalize('NFD');
    var o='',d=false;
    for(var i=0;i<s.length;i++){var c=s.charCodeAt(i);if(c>=768&&c<=879)continue;if((c>=97&&c<=122)||(c>=48&&c<=57)){o+=s.charAt(i);d=false;}else if(!d&&o){o+='-';d=true;}}
    if(o.slice(-1)==='-')o=o.slice(0,-1);
    return o.slice(0,64);
  }
  function nm(t){t=String(t||'');var n=t,d='';if(t.indexOf('|')>-1){var a=t.split('|');n=a[a.length-1].trim();d=a[0].trim();}else if(t.indexOf(' - ')>-1){var b=t.split(' - ');n=b[b.length-1].trim();d=b[0].trim();}return {n:n,d:d};}
  function fm(c){c=Math.round(c);return (c/100).toLocaleString('fr-FR',{style:'currency',currency:'EUR',minimumFractionDigits:c%100?2:0,maximumFractionDigits:2});}
  function img(u,w){if(!u)return '';u=String(u);if(u.indexOf('//')===0)u='https:'+u;return u+(u.indexOf('?')>-1?'&':'?')+'width='+w;}

  ready(function(){
    var root=document.documentElement,body=document.querySelector('[data-dxa-body]'),bar=document.querySelector('[data-dxa-bar]');
    var toc=document.querySelector('[data-dxa-toc]'),tl=document.querySelector('[data-dxa-tocl]'),hs=body?all('h2',body):[],links=[];

    if(body){
      all('table',body).forEach(function(t){if(t.parentNode&&t.parentNode.classList&&t.parentNode.classList.contains('dxa-table'))return;var w=document.createElement('div');w.className='dxa-table';t.parentNode.insertBefore(w,t);w.appendChild(t);});
      all('img',body).forEach(function(i){if(!i.getAttribute('loading'))i.setAttribute('loading','lazy');});
    }

    if(toc&&tl&&hs.length>=2){
      var seen={};
      hs.forEach(function(h,i){
        if(!h.id){var s=slug(h.textContent)||('partie-'+(i+1));while(seen[s])s+='-'+(i+1);h.id=s;}
        seen[h.id]=1;
        var li=document.createElement('li'),a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;li.appendChild(a);tl.appendChild(li);links.push(a);
      });
      toc.hidden=false;
    }

    var cp=document.querySelector('[data-dxa-copy]');
    if(cp)cp.addEventListener('click',function(){
      var u=location.origin+location.pathname,l=cp.querySelector('[data-dxa-copyl]');
      function ok(){if(l){l.textContent='Lien copié';setTimeout(function(){l.textContent='Copier le lien';},1800);}}
      if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(u).then(ok,function(){});else{var t=document.createElement('textarea');t.value=u;document.body.appendChild(t);t.select();try{document.execCommand('copy');ok();}catch(e){}t.remove();}
    });

    all('[data-dxa-products]').forEach(function(box){
      var hh=(box.getAttribute('data-dxa-products')||'').split(',').map(function(x){return x.trim();}).filter(Boolean).slice(0,6);
      if(!hh.length){box.remove();return;}
      Promise.all(hh.map(function(h){return fetch('/products/'+encodeURIComponent(h)+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});})).then(function(ps){
        ps=ps.filter(function(p){return p&&p.handle;});
        if(!ps.length){box.remove();return;}
        var t=box.getAttribute('data-title')||'Les luminaires de ce guide',u=box.getAttribute('data-url'),ul=box.getAttribute('data-url-label')||'Tout voir';
        var html='<p class="dxa-shop__h"><b>'+esc(t)+'</b>'+(u?'<a href="'+esc(u)+'">'+esc(ul)+'</a>':'')+'</p><div class="dxa-shop__g">';
        ps.forEach(function(p){
          var N=nm(p.title),v=(p.variants||[])[0]||{},pr=p.price||v.price||0,cp=p.compare_at_price||v.compare_at_price||0;
          html+='<a class="dxa-p" href="/products/'+esc(p.handle)+'"><span class="dxa-p__i">'+(p.featured_image?'<img src="'+esc(img(p.featured_image,600))+'" alt="'+esc(N.n)+'" loading="lazy" width="600" height="600">':'')+'</span><span class="dxa-p__b"><span class="dxa-p__n">'+esc(N.n)+'</span>'+(N.d?'<span class="dxa-p__d">'+esc(N.d)+'</span>':'')+'<span class="dxa-p__pr">'+fm(pr)+(cp>pr?'<s>'+fm(cp)+'</s>':'')+'</span><span class="dxa-p__go">Voir le luminaire</span></span></a>';
        });
        box.innerHTML=html+'</div>';
      });
    });

    var fq=all('.dxa-faq details');
    if(fq.length){
      var data={'@context':'https://schema.org','@type':'FAQPage',mainEntity:fq.map(function(d){var s=d.querySelector('summary'),c=d.cloneNode(true),cs=c.querySelector('summary');if(cs)cs.parentNode.removeChild(cs);return {'@type':'Question',name:(s?s.textContent:'').trim(),acceptedAnswer:{'@type':'Answer',text:c.textContent.trim()}};})};
      var sc=document.createElement('script');sc.type='application/ld+json';sc.textContent=JSON.stringify(data);document.head.appendChild(sc);
    }

    var top=-1,tick=false;
    function frame(){
      tick=false;
      var t=hdBottom(),vh=window.innerHeight;
      if(t!==top){top=t;root.style.setProperty('--dxa-top',t+'px');}
      if(bar&&body){var r=body.getBoundingClientRect(),p=cl((t+vh*.25-r.top)/Math.max(1,r.height-vh*.5),0,1);bar.parentNode.style.setProperty('--p',p.toFixed(4));}
      if(links.length){var id=null;hs.forEach(function(h){if(h.getBoundingClientRect().top<=t+vh*.3)id=h.id;});links.forEach(function(a){a.classList.toggle('is-on',a.getAttribute('href')==='#'+id);});}
    }
    function req(){if(!tick){tick=true;requestAnimationFrame(frame);}}
    window.addEventListener('scroll',req,{passive:true});
    window.addEventListener('resize',req);
    frame();

    if(tl)tl.addEventListener('click',function(e){
      var a=e.target.closest('a');if(!a)return;var el=document.getElementById(a.getAttribute('href').slice(1));if(!el)return;
      e.preventDefault();window.scrollTo({top:el.getBoundingClientRect().top+window.pageYOffset-hdBottom()-24,behavior:RM?'auto':'smooth'});
      if(history.replaceState)history.replaceState(null,'','#'+el.id);
    });
  });
})();